(function ($) {
    $('#tabcontainer .tabs').hide().eq(0).show();
    $('#tabcontainer-2 .tabs').hide().eq(0).show();
    $('#tabs li').click(function () {
        let num = $('#tabs li').index(this);
        $('#tabcontainer .tabs').hide().eq(num).show();
        $('#tabcontainer-2 .tabs').hide().eq(num).show();
    });

//button
    $('.open-other-nav').click(function(){
        $(this).toggleClass('active');
        $('.wrap-navigation').toggleClass('collapsed');
    });
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/custom/section-review_2024_cards_tabs.es6